import type React from 'react';

import { Link } from '@/js/libs/ui';

interface AccountLinkProps extends React.PropsWithChildren {
  id?: string;
  className?: string;
}

export const AccountLink: React.FC<AccountLinkProps> = ({ children, id, className }) =>
  id ? (
    <Link to={`/crm/accounts/${id}`} className={className}>
      {children}
    </Link>
  ) : (
    <span className={className}>{children}</span>
  );
